<app-gmao-spinner *ngIf="!materiel"></app-gmao-spinner>
<ng-container *ngIf="materiel">
    <p>Tous les matériels > {{materiel.ancestor_classe.designation}} > {{materiel.ancestor_materiel.designation}} >
        {{materiel.ancestor_serie.fournisseur}} ({{materiel.ancestor_serie.date_reception}},
        {{materiel.ancestor_serie.count}} élément(s)) > {{materiel.ancestor_unite.numero_serie}}</p>
    <div class="shadowed justify-content-center materiel-head">
        <div class="attributs">
            <p>Statut : </p>
            <p>{{materiel.ancestor_unite.statut}} [<a [routerLink]="['/installation', materiel.ancestor_unite.id_installation]">{{materiel.ancestor_unite.nom_installation}}</a>]</p>
        </div>
        <div class="attributs">
            <p>S/N : </p>
            <p>{{materiel.ancestor_unite.numero_serie}}</p>
        </div>
        <div class="attributs">
            <p>Adresse MAC :</p>
            <p>{{materiel.ancestor_unite.adresse_mac}}</p>
        </div>
        <div class="attributs">
            <p>Commentaire : </p>
            <p>{{materiel.ancestor_unite.commentaire}}</p>
        </div>
        <ng-container *ngIf="materiel.ancestor_unite.isComputer">
            <div class="attributs">
                <p>Utilisateur Windows :</p>
                <p>{{materiel.ancestor_unite.win_username}}</p>
            </div>
            <div class="attributs">
                <p>Mot de passe Windows : </p>
                <p>{{materiel.ancestor_unite.win_password}}</p>
            </div>
            <div class="attributs">
                <p>Mot de passe Splashtop : </p>
                <p>{{materiel.ancestor_unite.lmi_password}}</p>
            </div>
        </ng-container>
    </div>
    <!-- Add buttons to actions -->
    <div class="shadowed">
        <div class="table-responsive">
            <table class="table table-hover">
                <tbody>
                    <tr *ngFor="let action of materiel.mat_actions" >
                        <td>{{action.action_type}}</td>
                        <td>
                            <a [routerLink]="['/machine', action.id_machine]">{{action.numero_serie_machine}}</a>
                        </td>
                        <td>
                            <a [routerLink]="['/installation', action.id_installation]">{{action.nom_installation}} ({{action.statut_installation}})</a>
                        </td>
                        <td>{{convertDate(action.date_action)}}</td>
                        <td>{{action.descriptif}}</td>
                        <!-- <td></td> button to edit-->
                        <!-- <td></td> button to delete -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>